<template>
  <form-select
      v-model="selectedIds"
      :p-currencies="pCurrencies"
      :p-language="pLanguage"
      :p-dictionary="pDictionary"
      :p-urls="pUrls"
      :p-error-list="pErrorList"
      :p-src="pSrc"
      :p-src-id="pSrcId"
      :p-error-key="pErrorKey"
      :p-required="pRequired"
      p-select-id-prefix="campaign"
      :p-input-name="pInputName"
      :p-select-container="pSelectContainer"
      :p-disabled="pDisabled"
      :p-ref-list="campaignRefList"
      :p-multiple="pMultiple"
      p-dictionary-key-label="dictionary.campaign"
      :p-dictionary-key-select="dictionaryKeySelect">
    <template v-slot:form-select-hint>
      <p class="help-block" v-for="campaignRef in selectedCampaignRefs" :key="campaignRef.id">
        {{ 'dictionary.general.date.range' | i18nText(pDictionary) | i18nparams(0, campaignRef.params.startDate) | i18nparams(1, campaignRef.params.endDate) }}
      </p>
    </template>
  </form-select>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";
import FormSelect from "@/components/ui/FormSelect";

export default {
  name: "CampaignSelectSingle",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  components: {
    FormSelect
  },
  props: {
    value: [Number, Array],
    pErrorKey: String,
    pRequired: Boolean,
    pInputName: String,
    pSelectContainer: String,
    pDisabled: Boolean,
     pDataListUrl: {
        type: String,
        default: function() {
           return '/mediaplan/app/endpoints/json-api/ref/campaigns';
        }
     },
     pDataListInput: {
      type: Object,
      default: function() {
        return {
          output: 1 /* Group by media plans */
        }
      }
    },
     pMultiple: {
        type: Boolean,
        default: function () {
           return false;
        }
     },
    pDictionaryKeySelect: String
  },
  data: function () {
    return {
      campaignRefList: [],
      selectedIds: this.value
    }
  },
  methods: {
    refreshCampaignList: function(dataListInput) {
      let _component = this;
      $.ajax({
               type: "POST",
               url: _component.pDataListUrl,
               data: JSON.stringify(dataListInput),
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               }
             }).done(function (refList) {
        _component.campaignRefList = refList;

      });
    }
  },
  watch: {
    value: function (newValue) {
      this.selectedIds = newValue;
    },
    selectedIds: function () {
      this.$emit('input', this.selectedIds)
    },
    pDataListInput: function(newDataListInput) {
      this.refreshCampaignList(newDataListInput);
    }
  },
  computed: {
    selectedCampaignRefs: function () {
      return this.campaignRefList.reduce((campaigns, mp) => {
        campaigns.push(...mp.childDataRefs);
        return campaigns;
      }, []).filter(c => this.selectedIds === c.id);
    },
    dictionaryKeySelect: function() {
       if(this.pDictionaryKeySelect) return this.pDictionaryKeySelect;
       return this.pMultiple ? "dictionary.campaign.select.multiple" : "dictionary.campaign.select.single";
    }
  },
  mounted: function () {
    this.refreshCampaignList(this.pDataListInput);
  }
}
</script>

<style scoped>

</style>